import { render, staticRenderFns } from "./mortgageAllList.vue?vue&type=template&id=1fa536c5&scoped=true&lang=html&"
import script from "./mortgageAllList.vue?vue&type=script&lang=js&"
export * from "./mortgageAllList.vue?vue&type=script&lang=js&"
import style0 from "./mortgageAllList.vue?vue&type=style&index=0&id=1fa536c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa536c5",
  null
  
)

export default component.exports